import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";

function write__1(js) {
  return Atdgen_codec_runtime.Encode.list(function (param) {
    return Atdgen_codec_runtime.Encode.tuple2(Atdgen_codec_runtime.Encode.string, write_t, param);
  }, js);
}

function write__2(js) {
  return Atdgen_codec_runtime.Encode.nullable(write_t, js);
}

function write_t(js) {
  return Curry._1(Atdgen_codec_runtime.Encode.make(function (x) {
    if (typeof x === "number") {
      if (x >= 737157829) {
        if (x >= 748194550) {
          if (x >= 785140586) {
            if (x >= 936769581) {
              return Atdgen_codec_runtime.Encode.constr0("Time");
            } else {
              return Atdgen_codec_runtime.Encode.constr0("Unknown");
            }
          } else if (x >= 758940238) {
            return Atdgen_codec_runtime.Encode.constr0("Date");
          } else {
            return Atdgen_codec_runtime.Encode.constr0("Char");
          }
        } else if (x >= 737456202) {
          return Atdgen_codec_runtime.Encode.constr0("Bool");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("Biom");
        }
      } else if (x !== -883458824) {
        if (x >= 365180284) {
          if (x >= 642196241) {
            return Atdgen_codec_runtime.Encode.constr0("Newick");
          } else {
            return Atdgen_codec_runtime.Encode.constr0("Float");
          }
        } else if (x >= 3654863) {
          return Atdgen_codec_runtime.Encode.constr0("Int");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("String");
        }
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Type_not_available");
      }
    } else {
      var variant = x[0];

      if (variant >= 848054398) {
        if (variant >= 937413395) {
          if (variant >= 951904681) {
            return Atdgen_codec_runtime.Encode.constr1("Arrow", function (param) {
              return Atdgen_codec_runtime.Encode.tuple2(write_t, write_t, param);
            }, x[1]);
          } else {
            return Atdgen_codec_runtime.Encode.constr1("Tvar", Atdgen_codec_runtime.Encode.string, x[1]);
          }
        } else if (variant >= 925483562) {
          return Atdgen_codec_runtime.Encode.constr1("Sexp", Atdgen_codec_runtime.Encode.string, x[1]);
        } else {
          return Atdgen_codec_runtime.Encode.constr1("List", write_t, x[1]);
        }
      } else if (variant !== 216537025) {
        if (variant >= 847309489) {
          return Atdgen_codec_runtime.Encode.constr1("Record", function (param) {
            return Atdgen_codec_runtime.Encode.tuple2(write__1, write__2, param);
          }, x[1]);
        } else {
          return Atdgen_codec_runtime.Encode.constr1("Solvuu_type", Atdgen_codec_runtime.Encode.string, x[1]);
        }
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Nullable", write_t, x[1]);
      }
    }
  }), js);
}

function read__1(js) {
  return Atdgen_codec_runtime.Decode.list(function (param) {
    return Atdgen_codec_runtime.Decode.tuple2(Atdgen_codec_runtime.Decode.string, read_t, param);
  }, js);
}

function read__2(js) {
  return Atdgen_codec_runtime.Decode.nullable(read_t, js);
}

function read_t(js) {
  return Curry._1(Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Bool",
  /* `Single */
  [-306849112,
  /* Bool */
  737456202]],
  /* :: */
  [
  /* tuple */
  ["Char",
  /* `Single */
  [-306849112,
  /* Char */
  748194550]],
  /* :: */
  [
  /* tuple */
  ["Int",
  /* `Single */
  [-306849112,
  /* Int */
  3654863]],
  /* :: */
  [
  /* tuple */
  ["Float",
  /* `Single */
  [-306849112,
  /* Float */
  365180284]],
  /* :: */
  [
  /* tuple */
  ["String",
  /* `Single */
  [-306849112,
  /* String */
  -976970511]],
  /* :: */
  [
  /* tuple */
  ["Time",
  /* `Single */
  [-306849112,
  /* Time */
  936769581]],
  /* :: */
  [
  /* tuple */
  ["Date",
  /* `Single */
  [-306849112,
  /* Date */
  758940238]],
  /* :: */
  [
  /* tuple */
  ["Nullable",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Nullable */
        [216537025, x]
      );
    }, read_t, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["List",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `List */
        [848054398, x]
      );
    }, read_t, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Arrow",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Arrow */
        [951904681, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read_t, read_t, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Unknown",
  /* `Single */
  [-306849112,
  /* Unknown */
  785140586]],
  /* :: */
  [
  /* tuple */
  ["Tvar",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Tvar */
        [937413395, x]
      );
    }, Atdgen_codec_runtime.Decode.string, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Record",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Record */
        [847309489, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__1, read__2, param);
    }, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Biom",
  /* `Single */
  [-306849112,
  /* Biom */
  737157829]],
  /* :: */
  [
  /* tuple */
  ["Newick",
  /* `Single */
  [-306849112,
  /* Newick */
  642196241]],
  /* :: */
  [
  /* tuple */
  ["Solvuu_type",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Solvuu_type */
        [-861261133, x]
      );
    }, Atdgen_codec_runtime.Decode.string, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Sexp",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Sexp */
        [925483562, x]
      );
    }, Atdgen_codec_runtime.Decode.string, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Type_not_available",
  /* `Single */
  [-306849112,
  /* Type_not_available */
  -883458824]],
  /* [] */
  0]]]]]]]]]]]]]]]]]]), js);
}

function write_var(write__var) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (typeof x === "number") {
      return Atdgen_codec_runtime.Encode.constr0("Unknown");
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Tvar", write__var, x[1]);
    }
  });
}

function read_var(read__var) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Unknown",
  /* `Single */
  [-306849112,
  /* Unknown */
  785140586]],
  /* :: */
  [
  /* tuple */
  ["Tvar",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Tvar */
        [937413395, x]
      );
    }, read__var, param);
  }]],
  /* [] */
  0]]);
}

var write_scalar = Atdgen_codec_runtime.Encode.make(function (x) {
  if (x >= 737456202) {
    if (x >= 758940238) {
      if (x >= 936769581) {
        return Atdgen_codec_runtime.Encode.constr0("Time");
      } else {
        return Atdgen_codec_runtime.Encode.constr0("Date");
      }
    } else if (x >= 748194550) {
      return Atdgen_codec_runtime.Encode.constr0("Char");
    } else {
      return Atdgen_codec_runtime.Encode.constr0("Bool");
    }
  } else if (x !== 3654863) {
    if (x >= 365180284) {
      return Atdgen_codec_runtime.Encode.constr0("Float");
    } else {
      return Atdgen_codec_runtime.Encode.constr0("String");
    }
  } else {
    return Atdgen_codec_runtime.Encode.constr0("Int");
  }
});
var read_scalar = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Bool",
/* `Single */
[-306849112,
/* Bool */
737456202]],
/* :: */
[
/* tuple */
["Char",
/* `Single */
[-306849112,
/* Char */
748194550]],
/* :: */
[
/* tuple */
["Int",
/* `Single */
[-306849112,
/* Int */
3654863]],
/* :: */
[
/* tuple */
["Float",
/* `Single */
[-306849112,
/* Float */
365180284]],
/* :: */
[
/* tuple */
["String",
/* `Single */
[-306849112,
/* String */
-976970511]],
/* :: */
[
/* tuple */
["Time",
/* `Single */
[-306849112,
/* Time */
936769581]],
/* :: */
[
/* tuple */
["Date",
/* `Single */
[-306849112,
/* Date */
758940238]],
/* [] */
0]]]]]]]);

function write_nullable_type(write__t) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Nullable", write__t, x[1]);
  });
}

function read_nullable_type(read__t) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Nullable",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Nullable */
        [216537025, x]
      );
    }, read__t, param);
  }]],
  /* [] */
  0]);
}

function write_list_type(write__t) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("List", write__t, x[1]);
  });
}

function read_list_type(read__t) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["List",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `List */
        [848054398, x]
      );
    }, read__t, param);
  }]],
  /* [] */
  0]);
}

function write_arrow(write__t) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Arrow", function (param) {
      return Atdgen_codec_runtime.Encode.tuple2(write__t, write__t, param);
    }, x[1]);
  });
}

function read_arrow(read__t) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Arrow",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Arrow */
        [951904681, x]
      );
    }, function (param) {
      return Atdgen_codec_runtime.Decode.tuple2(read__t, read__t, param);
    }, param);
  }]],
  /* [] */
  0]);
}

export { read_t, write_t, read_var, write_var, read_scalar, write_scalar, read_nullable_type, write_nullable_type, read_list_type, write_list_type, read_arrow, write_arrow };
/* write_scalar Not a pure module */